const minuteToDiff = (value: number) => {
  const hoursDiff = Math.floor(Math.abs(value / 60))
  const minutesDiff = Math.abs(value % 60)
    .toFixed(0)
    .padStart(2, '0')

  const sign = value > 0 ? '+' : '-'
  const asHour = value === 0 || hoursDiff > 0

  if (asHour) {
    return `${value === 0 ? '' : sign}${hoursDiff}h${minutesDiff}`
  }

  return `${value === 0 ? '' : sign}${minutesDiff}mn`
}
export default minuteToDiff
